import React from 'react';
import { FaqProps } from '../index';
import { Form } from '../../../../components';
import {
  InstructionWrapper,
  TextField,
  ToggleSwitch
} from '../../../../components/fields';
import Heading from '../../../../_global/components/heading/Heading';
import './_styles.scss';

export default function ViewItem({
  data: { order, question, answer, is_active }
}: FaqProps) {
  const displayName = question ?? '';

  return (
    <div id='faq-view-item' className='read-only'>
      <Heading name={displayName} />
      <Form title='Faq Details'>
        <InstructionWrapper text='Faq order/sequence number and status' row>
          <TextField label='Order' value={order} readOnly />
          <ToggleSwitch
            label='Is active'
            className={'display-block'}
            value={is_active}
            readOnly
          />
        </InstructionWrapper>

        <InstructionWrapper text='Faq' row>
          <TextField label='Question' value={question} readOnly />
        </InstructionWrapper>

        <InstructionWrapper text='Faq answer' row>
          <TextField multiline={true} label='Answer' value={answer} readOnly />
        </InstructionWrapper>
      </Form>
    </div>
  );
}
